import React, { useState } from "react";
import { Container, Row, Col, Button, Collapse } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { CiFilter } from "react-icons/ci";

const Footer = () => {
    const [openTentangKami, setOpenTentangKami] = useState(false);
    const [openUntukPasien, setOpenUntukPasien] = useState(false);
    const [openUntukProfesional, setOpenUntukProfesional] = useState(false);

    return (
        <footer className="text-center py-3" style={{
            background: '#8d070e', color: 'white'
        }}>
            <Container>
                <p className="mb-0">© {new Date().getFullYear()} RS YARSI. All rights reserved.</p>
            </Container>
        </footer>
    );
};

export default Footer;
